<template>
    <div>
        <!-- 授课信息 -->
        <div class="card">
            <div class="card-header">
                授课信息
            </div>
            <div class="card-body">
                <div v-if="studentCourseData.length===0" class="alert alert-warning" :class="{'mb-0': !canEdit}">没有参训教师的授课信息</div>
                <table v-else class="table table-bordered table-striped" :class="{'mb-0': !canEdit}">
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 10%">序号</th>
                        <th class="text-center align-middle" style="width: 40%">授课名称</th>
                        <th class="text-center align-middle" style="width: 10%">教学层次</th>
                        <th class="text-center align-middle" style="width: 15%">课程时长</th>
                        <th class="text-center align-middle" style="width: 15%">授课年限</th>
                        <th class="text-center align-middle" style="width: 10%" v-if="canEdit">删除</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(course, index) in studentCourseData" :key="course.pkId">
                        <td class="text-center align-middle">{{ index + 1 }}</td>
                        <td class="text-left align-middle">{{ course.courseName }}</td>
                        <td class="text-center align-middle">{{ course.collegeLevelName }}</td>
                        <td class="text-center align-middle">{{ course.courseLength }}</td>
                        <td class="text-center align-middle">{{ course.trainLength }}</td>
                        <td class="text-center align-middle" v-if="canEdit">
                            <button type="button" class="btn btn-danger btn-sm"
                                    @click="btnDeleteStudentCourseInfo_Click(course.pkId)">删除
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <button v-if="canEdit" class="btn btn-primary" @click="btnAddStudentCourse_Click">添加授课信息</button>
            </div>
        </div>

        <b-modal v-model="isAddStudentCourseDialogOpen"
                 title="添加授课信息"
                 ok-title="确定" cancel-title="取消" @ok="addStudentCourseDialog_OK"
                 :no-close-on-backdrop="true">
            <form>
                <div class="form-group row">
                    <label for="inputDialogCourseName" class="col-sm-3 col-form-label text-right">课程名称</label>
                    <div class="col-sm-8">
                        <input type="text" class="form-control" id="inputDialogCourseName" placeholder="课程名称"
                               v-model="addStudentCourseInfo.courseName">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputDialogCollegeLevel" class="col-sm-3 col-form-label text-right">教学层次</label>
                    <div class="col-sm-8">
                        <select class="form-control" id="inputDialogCollegeLevel"
                                v-model="addStudentCourseInfo.collegeLevel">
                            <option v-for="code in collegeLevelEnum" :key="code.codeValue" :value="code.codeValue">
                                {{ code.codeContent }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputDialogCourseLength" class="col-sm-3 col-form-label text-right">课程长度</label>
                    <div class="col-sm-8">
                        <input type="text" class="form-control" id="inputDialogCourseLength" placeholder="课程长度"
                               v-model="addStudentCourseInfo.courseLength">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputDialogTrainLength" class="col-sm-3 col-form-label text-right">授课年限</label>
                    <div class="col-sm-8">
                        <input type="text" class="form-control" id="inputDialogTrainLength" placeholder="授课年限"
                               v-model="addStudentCourseInfo.trainLength">
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import baseApi from "@/utils/api/base";
import userApi from "@/utils/api/user";
export default {
    name: "StudentCourseEdit",
    props: {
        studentId: {type: String, required: true},
        canEdit: {type: Boolean, required: false, default: true}
    },
    data: function () {
        return {
            collegeLevelEnum: [],

            studentCourseData: [],
            addStudentCourseInfo: {
                studentId: this.studentId,
                courseName: '',
                collegeLevel: 1,
                courseLength: '',
                trainLength: ''
            },
            isAddStudentCourseDialogOpen: false,
        };
    },
    mounted() {
        this.getCollegeLevelEnumData();
        this.getStudentCourseData();
    },
    methods: {
        getCollegeLevelEnumData() {
            baseApi.codeValue.getBaseCollegeLevelEnum().then(res => {
                this.collegeLevelEnum = res.data;
            });
        },

        getStudentCourseData() {
            userApi.student.course.getStudentCourseData(this.studentId).then(res => {
                this.studentCourseData = res.data;
            })
        },

        btnAddStudentCourse_Click() {
            this.addStudentCourseInfo = {
                studentId: this.studentId,
                courseName: '',
                collegeLevel: 1,
                courseLength: '',
                trainLength: ''
            };
            this.isAddStudentCourseDialogOpen = true;
        },
        addStudentCourseDialog_OK() {
            userApi.student.course.insertStudentCourseInfo(this.addStudentCourseInfo).then(res => {
                this.getStudentCourseData();
            });
        },
        btnDeleteStudentCourseInfo_Click(pkId) {
            if (confirm('是否删除此项授课信息？')) {
                userApi.student.course.deleteStudentCourseInfoById(pkId).then(res => {
                    this.getStudentCourseData();
                });
            }
        },
    }
}
</script>

<style scoped>

</style>